@if (agencySocialLinks$ | async; as socialLinks) {
  @if (socialLinks.length) {
    <div class="floating-links" [@fadeInOut] [ngClass]="{ over: true }">
      <app-social-media-links
        [isSquare]="isSquareButton()"
        [socialLinks]="socialLinks"></app-social-media-links>
    </div>
  }
}
